(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('bubbaTransitionHook', bubbaTransitionHook);

    var noop = angular.noop;

    bubbaTransitionHook.$inject = ['signInManager', 'homeStateName', 'loginStateName'];
    function bubbaTransitionHook(signInManager, loginStateName, homeStateName) {
        return { onBefore: [{ from: isRoot, to: isNotHomeOrLogin }, hook] };

        function isRoot(state) {
            return state.name === '';
        }

        function isNotHomeOrLogin(state) {
            return state.name !== homeStateName && state.name !== loginStateName;
        }

        function hook(transition) {
            return signInManager.isSignedIn().catch(noop);
        }
    }
})();